import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Label,
  useToast,
} from '@ais-ui/ui-core';
import React, { useState } from 'react';
import { useDeleteAton } from '@ais-ui/api';
import { AtoN } from '@ais-ui/api-spec/config';
import { mutateCallbacks } from '../../utils/mutateCallbacks';
import { useLocalization } from '@ais-ui/locale-management';

interface DeleteAtonProps {
  aton: AtoN;
  showDialog: boolean;
  setShowDialog: React.Dispatch<React.SetStateAction<boolean>>;
}

export function DeleteAton({
  aton,
  showDialog,
  setShowDialog,
}: DeleteAtonProps) {
  const { messages } = useLocalization();
  const { mutate } = useDeleteAton();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const { toast } = useToast();

  const onDelete = (event: React.FormEvent) => {
    event.preventDefault();

    const atonName = aton.name ? aton.name : 'unknown AtoN';

    setIsSubmitting(true);

    const callBacks = mutateCallbacks(
      toast,
      messages,
      'delete',
      'aton',
      setIsSubmitting,
      setShowDialog
    );

    if (!aton.uuid) {
      toast({
        className: 'delete-aton-error-toast',
        title: messages.genericToastTitleError,
        description: messages.atonDeleteFailed.replace('{label}', atonName),
        variant: 'destructive',
      });
      setShowDialog(false);
      setIsSubmitting(false);
      return;
    }

    mutate(aton.uuid, callBacks);
  };

  return (
    <Dialog open={showDialog} onOpenChange={setShowDialog}>
      <DialogContent id="mutate-aton-dialog">
        <DialogHeader>
          <DialogTitle>{messages.atonDeleteTitle}</DialogTitle>
          <DialogDescription>{messages.atonDeleteWarning}</DialogDescription>
        </DialogHeader>
        <form onSubmit={onDelete}>
          <div className="grid grid-cols-[auto_minmax(50%,_1fr)] 4 gap-x-2 items-baseline">
            <Label className="font-light">{messages.atonDeleteAtonName}</Label>
            <Label htmlFor="aton-name">{aton.name}</Label>
          </div>
          <DialogFooter className="p-4">
            <Button
              variant="destructive"
              id="aton-confirm-delete-button"
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting
                ? messages.genericSubmitting
                : messages.genericSubmit}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
